import { render, staticRenderFns } from "./JalaHarvestResourceName.vue?vue&type=template&id=132d8226&"
import script from "./JalaHarvestResourceName.vue?vue&type=script&lang=js&"
export * from "./JalaHarvestResourceName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports